import store from "store";

export const cacheItems = {
  USER_TOKEN: "USER_TOKEN",
  USER_REFRESH_TOKEN: "USER_REFRESH_TOKEN",
  USER_UUID: "USER_UUID",
  POP_UP_LOCATION_INSTANCE_UUID: "POP_UP_LOCATION_INSTANCE_UUID",
  FF_LABELING: "FF_LABELING",
  WHITE_LABEL_THEME: "WHITE_LABEL_THEME",
  PREVIOUS_ZIP_CODE: "PREVIOUS_ZIP_CODE"
};

class Cache {
  constructor(cache) {
    this.cache = cache;
  }

  setItem(name, value) {
    return this.cache.set(name, value);
  }

  getItem(name) {
    return this.cache.get(name);
  }

  removeItem(name) {
    return this.cache.remove(name);
  }

  clearAll() {
    return this.cache.clearAll();
  }
}

export default new Cache(store);
